import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';
import Select from 'flarum/common/components/Select';
import Link from 'flarum/components/Link';
import { showPhoneError, showPhoneSuccess } from '../helpers/phoneAlerts';

export default class LinkModal extends Modal {
    oninit(vnode){
        super.oninit(vnode);
        this.region = "ChineseMainland";
    }

    className() {
        return `SMSAuthLinkModal Modal--small`;
    }

    title() {
        return app.translator.trans(`lakevy-phone-binding.forum.modals.link.title`);
    }

    content() {        
        return (
            <div className="Modal-body">
                <div className="Form Form--centered">
                    <div className="Form-group">

                        <div className="SMSAuthPhoneRow">
                            {Select.component({
                                wrapperAttrs: {
                                    className: 'SMSAuthCountrySelect',
                                },
                                options: { ChineseMainland: '86' },
                                value: this.region,
                                onchange: (val) => this.region = val,
                            })}

                            <input className="FormControl SMSAuthPhoneInput"
                                placeholder={app.translator.trans(`lakevy-phone-binding.forum.modals.link.phone`)}
                                oninput={e => this.phone = e.target.value}
                                disabled={this.inputDisabled}
                            />
                        </div>

                        <input className="FormControl SMSAuthVerificationCode"
                            placeholder={app.translator.trans(`lakevy-phone-binding.forum.modals.link.code`)}
                            oninput={e => this.code = e.target.value}
                            style={{display:this.display ? "block" : "none"}}
                        ></input>

                        <Button className={`Button Button--primary SMSAuthSendButton`} loading={this.loading} disabled={this.loading}
                            onclick={() => this.sendSMS(this.phone,this.region)} style={{display:this.displaySend}}>
                            {app.translator.trans(`lakevy-phone-binding.forum.buttons.send`)}
                        </Button>
                        {this.tips()}
                        <Button className={`Button Button--primary SMSAuthSubmitButton`} style={{display:this.display ? "block" : "none"}}
                            onclick={() => this.submit(this.phone, this.code, this.region)}>
                            {app.translator.trans(`lakevy-phone-binding.forum.buttons.submit`)}
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    tips(){
        if(app.forum.data.attributes.lakevyPhoneBindingTips){
            const title = app.forum.data.attributes.lakevyPhoneBindingTipsNoticeTitle;
            const body = app.forum.data.attributes.lakevyPhoneBindingTipsNoticeBody;

            return (
                <div className="phone-tips" style={{display:this.displaySend}}>
                    {title ? <div>{title}</div> : null}
                    {body ? <p className="SMSAuthLegalNotice">{body}</p> : null}
                    <div className="m-t-10">
                        {
                            app.forum.data.attributes.lakevyPhoneBindingTipsOneTitle?
                            <Link style="color:var(--control-color);" href={app.forum.data.attributes.lakevyPhoneBindingTipsOneUrl}
                            external={true} target="_blank">{app.forum.data.attributes.lakevyPhoneBindingTipsOneTitle}
                            </Link>:""
                        }
                        {
                            app.forum.data.attributes.lakevyPhoneBindingTipsTwoTitle?
                            <Link style="color:var(--control-color);" href={app.forum.data.attributes.lakevyPhoneBindingTipsTwoUrl}
                            external={true} target="_blank">{app.forum.data.attributes.lakevyPhoneBindingTipsTwoTitle}
                            </Link>:""
                        }
                        {
                            app.forum.data.attributes.lakevyPhoneBindingTipsThreeTitle?
                            <Link style="color:var(--control-color);" href={app.forum.data.attributes.lakevyPhoneBindingTipsThreeUrl}
                            external={true} target="_blank">{app.forum.data.attributes.lakevyPhoneBindingTipsThreeTitle}
                            </Link>:""
                        }
                    </div>
                </div>
            )
        }
    }

    sendSMS(phone,region) {
        var t = typeof phone;
        if(t != 'string'){
            return;
        }
        this.loading = true;
        this.inputDisabled = true;
        if(phone.length==0){
            this.loading = false;
            this.inputDisabled = false;
            showPhoneError('wrong_num');
            return;
        }
        if(region=="ChineseMainland" && phone.length!=11){
            this.loading = false;
            this.inputDisabled = false;
            showPhoneError('wrong_num');
            return;
        }
        app
            .request({
                url: app.forum.attribute('apiUrl') + "/auth/sms" + '/send',
                method: 'POST',
                body: { phone, region },
                // Errors are translated below. Prevent Flarum's default handler
                // from showing the raw API code as a second alert.
                errorHandler: () => {},
            }).catch((error) => {
                this.inputDisabled = false;
                this.loading = false;
                showPhoneError(error);
                return null;
            }).then((result) => {
                if (!result) {
                    m.redraw();
                    return;
                }
                this.loading = false;
                this.display = true;
                
                this.inputDisabled = true;
                this.displaySend = "none";

                if(!result.status){
                    switch(result.msg){
                        case "code_exist":
                            showPhoneError('code_exist', { time: result.time });
                            break;
                        case "code_null":
                            showPhoneError('code_null');
                            break;
                        case "code_expired":
                            showPhoneError('code_expired');
                            break;
                        case "code_invalid":
                            showPhoneError('code_invalid');
                            break;
                        case "phone_exist":
                            this.displaySend = "block";
                            this.display = false;
                            this.inputDisabled = false;
                            showPhoneError('phone_exist');
                            break;
                        case "sms_service_unavailable":
                        case "sms_rate_limited":
                        case "sms_daily_limit":
                            this.displaySend = "block";
                            this.display = false;
                            this.inputDisabled = false;
                            showPhoneError(result.msg);
                            break;
                        default:
                            this.inputDisabled = false;
                            showPhoneError(result.msg);
                            break;
                    }
                    return;
                }
                showPhoneSuccess('send_success');
            });
    }

    submit(phone,code,region){
        var t = typeof phone;
        var c = typeof code;
        if(t != 'string' || c != 'string'){
            return;
        }
        const user = app.session.user;
        user
          .save({
            phone: phone,
            code: code,
            region:region
          })
          .catch((error) => {
                showPhoneError(error);
                return
            })
          .then((res) => {
                if(res){
                    this.hide();
                    showPhoneSuccess('link_success');
                    m.redraw();
                    window.location.reload();
                }
          });
    }
}
